/** 600 → "10:00", 65 → "1:05". Fractions are floored. */
export function formatDuration(totalSeconds: number): string {
  const safe = Math.max(0, totalSeconds);
  const minutes = Math.floor(safe / 60);
  const seconds = Math.floor(safe % 60);
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
}

/** Local wall-clock time as "HH:MM". */
export function formatClockMinutes(epochMs: number): string {
  return new Date(epochMs).toTimeString().slice(0, 5);
}

const MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

function sameLocalDay(a: Date, b: Date): boolean {
  return a.toDateString() === b.toDateString();
}

/** "TODAY 06:12", "YESTERDAY 22:40", "03 OCT 14:05", or "NEVER" — the ward card's last-cycle line. */
export function formatLastCycle(isoTime: string | null, now: number): string {
  if (!isoTime) return 'NEVER';
  const at = new Date(isoTime);
  const time = at.toTimeString().slice(0, 5);
  if (sameLocalDay(at, new Date(now))) return `TODAY ${time}`;
  if (sameLocalDay(at, new Date(now - 86_400_000))) return `YESTERDAY ${time}`;
  return `${String(at.getDate()).padStart(2, '0')} ${MONTHS[at.getMonth()]} ${time}`;
}

export function bedNumber(index: number): string {
  return String(index + 1).padStart(2, '0');
}

export function bedKey(wardCode: string, bed: string): string {
  return `${wardCode}-${bed}`;
}

export function targetLabel(wardCode: string, bed: string): string {
  return `WARD ${wardCode} · BED ${bed}`;
}
